import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { IVendor } from 'models/vendor';
import { useTranslation } from 'react-i18next';
import { IUserInput } from 'models/users';
import { ICompany } from 'models/company';


interface Props {
  open: boolean;
  loading: boolean;
  roles: any[];
  input: IUserInput;
  companies: ICompany[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const AddUser: React.FC<Props> = ({ open, input, companies, loading, onClose, onSubmit, onChanges, roles }) => {
  const { t } = useTranslation()
  let basicFields1: IFormField[] = [
    {
      name: 'userName',
      label: t('T_username'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_username'),
      internalLabel: true, required: true
    },

    {
      name: 'email',
      label: t('T_email'),
      type: InputTypes.EMAIL,
      placeholder: t('T_enter_email'),
      internalLabel: true, required: true
    },
    {
      name: 'roleName',
      label: t('T_role_name'),
      type: InputTypes.SELECT,
      placeholder: t('T_enter_role_name'),
      internalLabel: true,
      options: roles.map(role => { return { label: role.name, value: role.name } }),
      required: true
    },
    {
      name: 'companyId',
      label: t('T_company'),
      type: InputTypes.SELECT,
      placeholder: 'Enter company',
      internalLabel: true,
      hidden: !(input.roleName === "CompanyAdmin" || input.roleName === "CorporateAdmin"),
      options: companies.map(company => { return { label: company.name, value: company.id } }),
      required: true
    },

  ];

  let basicFields2: IFormField[] = [
    {
      name: 'countryCode',
      label: t('T_country_code'),
      type: InputTypes.COUNTRY,
      internalLabel: true, required: true
    },



  ];

  let basicFields3: IFormField[] = [
    {
      name: 'phoneNumber',
      label: t('T_phone_number'),
      type: InputTypes.NUMBER,
      placeholder: t('T_enter_phone_number'),
      internalLabel: true, required: true
    },


  ];

  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_user')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields1} onChange={onChanges} />
        <div>
          <div style={{ display: 'flex' }}>
            <div style={{ width: '25%' }}>
              <Form
                fields={basicFields2}
                onChange={onChanges}
              />
            </div>

            <div style={{ width: '75%' }}>
              <Form
                fields={basicFields3}
                onChange={onChanges}
              />
            </div>
          </div>
        </div>
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddUser;
